/**
 * The form field for every admin screen: label ABOVE the control.
 *
 * This is the app-wide convention (see CLAUDE.md) built on the shared
 * `InputWrapper` the Loan Application uses — the label is a standalone
 * `InputLabel` sitting 3px above the control, wrapping rather than truncating,
 * with the required asterisk inside it and helper text below the control.
 *
 * The control passed as `children` must NOT be given a MUI `label`. Omitting it
 * is what suppresses the notched outline; there is no `notched={false}` to set.
 *
 * Sizing is the section's: 12.5px in the page ink, rather than the theme's muted
 * resting-label grey — that grey is right when a floating label doubles as a
 * placeholder, and reads as placeholder text when it sits above a filled control.
 */
import PropTypes from "prop-types";

import InputWrapper from "../../../components/inputs/shared/InputWrapper";
import { A } from "./adminTokens";

const LABEL_SX = {
  fontSize: 12.5,
  fontWeight: 400,
  lineHeight: 1.4375,
  color: A.ink,
};

export const AdminField = ({
  label,
  required,
  helperText,
  sx,
  labelSx,
  helperSx,
  children,
}) => (
  <InputWrapper
    fullWidth
    label={label}
    required={required}
    helperText={helperText}
    sx={sx}
    labelSx={labelSx || LABEL_SX}
    helperSx={helperSx}
  >
    {children}
  </InputWrapper>
);

AdminField.propTypes = {
  label: PropTypes.node,
  required: PropTypes.bool,
  helperText: PropTypes.node,
  sx: PropTypes.object,
  /** Replaces the section label style (e.g. FIELD_TEXT.label). */
  labelSx: PropTypes.object,
  helperSx: PropTypes.object,
  children: PropTypes.node,
};

export default AdminField;
